import { render, staticRenderFns } from "./TransferRequest.vue?vue&type=template&id=0930c62a&scoped=true"
import script from "./TransferRequest.vue?vue&type=script&lang=js"
export * from "./TransferRequest.vue?vue&type=script&lang=js"
import style0 from "./TransferRequest.vue?vue&type=style&index=0&id=0930c62a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0930c62a",
  null
  
)

export default component.exports